/* eslint-disable import/no-duplicates */
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO } from 'date-fns';

import { Container, Button, Row, Col } from 'react-bootstrap';

import api from '../../../services/api';

import { TIPO_USUARIO } from '../../../utils/funcoes';

import { useToast } from '../../../hooks/toast';
import { useAuth } from '../../../hooks/auth';

import Input from '../../../components/Input';
import Loading from '../../../components/Loading';

import getValidationErrors from '../../../utils/getValidationErrors';

import getResponseErrors from '../../../utils/getResponseErrors';
import PageInfo from '../../../components/PageInfo';
import HeaderRelatorio from '../HeaderRelatorio';

import { htmlDecode, htmlEncode } from '../../../utils/funcoes';

interface IRetornoEnganjamentoWhatsappDTO {
  PacCodigo: number;
  PacNome: string;
  AgeCodigo: string;
  ConNome: string;
  CprHistorico: string;
  CprValorPag: number;
  valorFormatado: string;
  created_at: Date;
  AgeInicio: string;
  createdFormatado: string;
  ageInicioFormatado: string;
}

interface IRelatorioFormatado {
  valorTotalGeral: string;
  totalRegistros: number;
  dados: IRetornoEnganjamentoWhatsappDTO[];
}

interface IFormBusca {
  dataInicio: Date;
  dataFim: Date;
  dataInicioP: Date;
  dataFimP: Date;
}

interface IDataExibe {
  dataHora: string;
  dataDiaSemana: string;
}

const EnganjamentoWhatsapp: React.FC = () => {
  const history = useHistory();
  const { addToast } = useToast();
  const { user } = useAuth();

  const formRefBusca = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [dadosRelatorio, setDadosRelatorio] = useState<IRelatorioFormatado>();

  const initialData = {
    dataInicio: format(new Date(), 'yyyy-MM-dd'),
    dataFim: format(new Date(), 'yyyy-MM-dd'),
    dataInicioP: format(new Date(), 'yyyy-MM-dd'),
    dataFimP: format(new Date(), 'yyyy-MM-dd'),
  };
  const [dataExibe, setDataExibe] = useState<IDataExibe>();

  const informacoesPagina = `<b>Descrição:</b> Exibe Pacientes cadastrado pelo whatsapp no periodo e qual foi o consumo. `;

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ATENDENTE) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        setDadosRelatorio(undefined);
        formRefBusca.current?.setErrors({});
        const schema = Yup.object().shape({
          dataInicio: Yup.date().required(),
          dataFim: Yup.date().required(),
          dataInicioP: Yup.date().required(),
          dataFimP: Yup.date().required(),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        const dataInicioSelecionada = parseISO(dados.dataInicio.toString());
        const dataFimSelecionada = parseISO(dados.dataFim.toString());
        const dataInicioPSelecionada = parseISO(dados.dataInicioP.toString());
        const dataFimPSelecionada = parseISO(dados.dataFimP.toString());

        const dataInicioFormatada = format(dataInicioSelecionada, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFimSelecionada, 'yyyy-MM-dd');
        const dataInicioPFormatada = format(
          dataInicioPSelecionada,
          'yyyy-MM-dd',
        );
        const dataFimPFormatada = format(dataFimPSelecionada, 'yyyy-MM-dd');

        setDataExibe({
          dataDiaSemana: `${format(
            dataInicioSelecionada,
            'dd/MM/yyyy',
          )} até ${format(dataFimSelecionada, 'dd/MM/yyyy')}`,
          dataHora: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
        });

        const response = await api.get<IRetornoEnganjamentoWhatsappDTO[]>(
          `/relatorios/enganjamentoWhatsapp?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}&dataInicioP=${dataInicioPFormatada}&dataFimP=${dataFimPFormatada}`,
        );

        const dadosFormatados: IRelatorioFormatado = {
          valorTotalGeral: response.data
            .reduce((acc, item) => acc + item.CprValorPag, 0)
            .toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          totalRegistros: response.data.length,
          dados: response.data.map(rel => {
            const datas = rel.AgeInicio.split('@@#@@');

            const datasFormatadas = datas.map(dataStr =>
              format(new Date(dataStr), 'dd/MM/yyyy'),
            );

            return {
              ...rel,
              ageInicioFormatado: datasFormatadas.join('<br />'),
              CprHistorico: rel.CprHistorico.replace(/@@#@@/g, '<br />'),
              ConNome: rel.ConNome.replace(/@@#@@/g, '<br />'),
              valorFormatado: rel.CprValorPag.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              }),
              createdFormatado: format(new Date(rel.created_at), 'dd/MM/yyyy'),
            };
          }),
        };

        // const ordenadoFormatado = ordenado.map(ord => {
        //   return {
        //     grupo: ord[0].ConNome,
        //     totalRegistros: ord.length,
        //     dados: ord,
        //   };
        // });

        setDadosRelatorio(dadosFormatados);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível carregar dados',
            description: mensagem,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}
      <>
        <div className="d-print-none bg-white border p-2 mb-2">
          <div className="p-2 mb-2 d-flex justify-content-between">
            <h2 id="topoBusca">Enganjamento Whatsapp</h2>
            <PageInfo
              descricao={informacoesPagina}
              permissao={TIPO_USUARIO.ATENDENTE_CAIXA}
            />
          </div>
          {user && (
            <Form
              ref={formRefBusca}
              initialData={initialData}
              onSubmit={handleSubmitBusca}
            >
              <Row>
                <Col md={2}>
                  <Input name="dataInicioP" label="De" type="date" required />
                </Col>
                <Col md={2}>
                  <Input name="dataFimP" label="Até" type="date" required />
                </Col>
                <Col md={2}>
                  <Input name="dataInicio" label="De" type="date" required />
                </Col>
                <Col md={2}>
                  <Input name="dataFim" label="Até" type="date" required />
                </Col>
                <Col md={2}>
                  <br />
                  <Button type="submit" size="sm" variant="outline-secondary">
                    BUSCAR
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>

        <HeaderRelatorio
          dataImpressao={dataExibe?.dataHora}
          titulo={`Enganjamento Whatsapp ${dataExibe?.dataDiaSemana || ''}`}
        />

        <div className="bg-white border p-2">
          {dadosRelatorio && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th>Paciente</th>
                    <th>Agenda</th>
                    <th>Procedimento</th>
                    <th style={{ width: '80px' }}>Valor</th>
                    <th style={{ width: '80px' }}>Cadastro</th>
                    <th style={{ width: '80px' }}>Agendamento</th>
                  </tr>
                </thead>
                <tbody>
                  {dadosRelatorio &&
                    dadosRelatorio.dados.map(rel => (
                      <tr
                        key={`agenda-${rel.AgeCodigo}-${rel.PacCodigo}`}
                        data-id={rel.AgeCodigo}
                        style={{ fontSize: '.7rem', height: '30px' }}
                      >
                        <td>{`${rel.PacCodigo} - ${rel.PacNome}`}</td>
                        <td
                          dangerouslySetInnerHTML={{
                            __html: htmlDecode(rel.ConNome),
                          }}
                        />
                        <td
                          dangerouslySetInnerHTML={{
                            __html: htmlDecode(rel.CprHistorico),
                          }}
                        />
                        <td>{rel.valorFormatado}</td>
                        <td>{rel.createdFormatado}</td>
                        <td
                          dangerouslySetInnerHTML={{
                            __html: htmlDecode(rel.ageInicioFormatado),
                          }}
                        />
                      </tr>
                    ))}
                  <tr
                    key="total"
                    data-id="00000000"
                    style={{
                      fontSize: '.7rem',
                      height: '30px',
                      fontWeight: 'bold',
                    }}
                  >
                    <td
                      colSpan={3}
                      style={{
                        textAlign: 'end',
                      }}
                    >
                      Total:
                    </td>
                    <td colSpan={3}>{dadosRelatorio?.valorTotalGeral}</td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
        </div>
      </>
    </Container>
  );
};

export default EnganjamentoWhatsapp;
